var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (news, undefined) {
buf.push("<div class=\"partner2-news\">");
// iterate news
;(function(){
  var $$obj = news;
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var item = $$obj[$index];

buf.push("<div class=\"partner2-news-item\"><div class=\"partner2-news-item-subtitle\">" + (jade.escape(null == (jade_interp = item.subtitle) ? "" : jade_interp)) + "</div><div class=\"partner2-news-item-title\"><a" + (jade.attr("href", item.titleLink, true, true)) + ">" + (jade.escape(null == (jade_interp = item.title) ? "" : jade_interp)) + "</a></div><div class=\"partner2-news-item-time\">" + (jade.escape(null == (jade_interp = item.time) ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var item = $$obj[$index];

buf.push("<div class=\"partner2-news-item\"><div class=\"partner2-news-item-subtitle\">" + (jade.escape(null == (jade_interp = item.subtitle) ? "" : jade_interp)) + "</div><div class=\"partner2-news-item-title\"><a" + (jade.attr("href", item.titleLink, true, true)) + ">" + (jade.escape(null == (jade_interp = item.title) ? "" : jade_interp)) + "</a></div><div class=\"partner2-news-item-time\">" + (jade.escape(null == (jade_interp = item.time) ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div>");}.call(this,"news" in locals_for_with?locals_for_with.news:typeof news!=="undefined"?news:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
module.exports = template;